/** Financial-year pills above pay-month pills, each with a status dot. */
import type { FinancialYear, MonthStatus, PayMonth } from "../../payroll/api";

const STATUS_LABEL: Record<MonthStatus, string> = {
  not_started: "not started",
  uploaded: "uploaded",
  submitted: "submitted",
  posted: "posted in iplicit",
};

export default function MonthPills({
  years, fyCode, month, onPickYear, onPickMonth,
}: {
  years: FinancialYear[];
  fyCode: string | null;
  month: PayMonth | null;
  onPickYear: (fy: string) => void;
  onPickMonth: (m: PayMonth) => void;
}) {
  const year = years.find((y) => y.fyCode === fyCode);

  return (
    <div className="pill-stack">
      <div className="pill-row">
        <span className="pill-row__label">Financial year</span>
        {years.map((y) => (
          <button
            key={y.fyCode}
            className={`month-pill${y.fyCode === fyCode ? " active" : ""}`}
            onClick={() => onPickYear(y.fyCode)}
            title={`${y.fyCode} — ${y.status}`}
          >
            {y.fyCode}
          </button>
        ))}
      </div>

      <div className="pill-row">
        <span className="pill-row__label">Pay month</span>
        {(year?.months ?? []).map((m) => (
          <button
            key={m.periodCode}
            className={`month-pill${m.periodCode === month?.periodCode ? " active" : ""}`}
            onClick={() => onPickMonth(m)}
            title={`${m.monthLabel} · period ${m.periodCode} · ${STATUS_LABEL[m.status]}`}
          >
            <span className={`status-dot status-dot--${m.status}`} />
            {m.monthLabel}
          </button>
        ))}
      </div>

      <div className="pill-legend">
        <span><span className="status-dot status-dot--not_started" />Not started</span>
        <span><span className="status-dot status-dot--uploaded" />Uploaded</span>
        <span><span className="status-dot status-dot--submitted" />Submitted</span>
        <span><span className="status-dot status-dot--posted" />Posted in iplicit</span>
      </div>
    </div>
  );
}
